import { getLocale, getString } from '../locale'

export type PageSection = 'dashboards' | 'artifacts' | 'administration' | 'user'

export interface IPage {
    path: string
    label: () => string
    section: PageSection
    externalHref?: string
    permissionKey?: string
}

export interface IPageSection {
    id: PageSection
    label: () => string
}

export const pageSections: IPageSection[] = [
    { id: 'dashboards', label: () => getString('pagesections.dashboards') },
    { id: 'artifacts', label: () => getString('pagesections.artifacts') },
    { id: 'administration', label: () => getString('pagesections.administration') },
    { id: 'user', label: () => getString('pagesections.user') },
]

export const pagesBySection = (section: PageSection): IPage[] => {
    return pages.filter(page => page.section === section)
}

export const pages = [
    { path: '/', label: () => getString('pagelabels.dashboard_internal'), section: 'dashboards', permissionKey: 'page.dashboard_internal' },
    { path: '/ext', label: () => getString('pagelabels.dashboard_external'), section: 'dashboards', permissionKey: 'page.dashboard_external' },
    // { path: '/datacenter', label: () => getString('pagelabels.datacenter') },
    { path: '/software-manager', label: () => getString('pagelabels.software-manager'), section: 'artifacts', permissionKey: 'page.software_manager' },
    { path: '/mobile-apps', label: () => getString('pagelabels.mobile_apps'), section: 'artifacts', permissionKey: 'page.mobile_apps' },
    { path: '/usb-flash-artifacts', label: () => getString('pagelabels.usb_flash_artifacts'), section: 'artifacts', permissionKey: 'page.usb_flash_artifacts' },
    { path: '/usb-flasher', label: () => getString('pagelabels.usb_flasher_web'), section: 'artifacts', externalHref: '/usb-flasher', permissionKey: 'page.usb_flasher_web' },
    { path: '/usb-flash-erase', label: () => getString('pagelabels.usb_flash_erase_web'), section: 'artifacts', externalHref: '/usb-flash-erase', permissionKey: 'page.usb_flash_erase_web' },
    { path: '/usb-serial-monitor', label: () => getString('pagelabels.usb_serial_monitor_web'), section: 'artifacts', externalHref: '/usb-serial-monitor', permissionKey: 'page.usb_serial_monitor_web' },
    { path: '/quicksupport', label: () => getString('pagelabels.quicksupport'), section: 'artifacts', externalHref: '/quicksupport', permissionKey: 'page.quicksupport' },
    { path: '/ltsp101-catalog', label: () => getString('ltsp101_catalog.title'), section: 'artifacts', permissionKey: 'page.ltsp101_catalog' },
    { path: '/admin', label: () => (getLocale() === 'he' ? 'פעולות ניהול' : getString('pagelabels.admin')), section: 'administration', permissionKey: 'page.admin' },
    { path: '/license-key-manager', label: () => getString('admin.license_manager'), section: 'administration', permissionKey: 'page.admin' },
    { path: '/users-management', label: () => (getLocale() === 'he' ? 'משתמשים והרשאות' : 'Users & Permissions'), section: 'administration', permissionKey: 'page.users_management' },
    { path: '/roles-permissions', label: () => (getLocale() === 'he' ? 'תפקידים והרשאות' : 'Roles & Permissions'), section: 'administration', permissionKey: 'page.roles_permissions' },
    { path: '/connected-devices', label: () => (getLocale() === 'he' ? 'מכשירים מחוברים' : 'Connected Devices'), section: 'user', permissionKey: 'page.connected_devices' },
] as IPage[]
